import { createAsyncThunk } from "@reduxjs/toolkit";
import { fetchSimilarProducts } from "./similarProducts.service";
import {
  SimilarProductsRequest,
  SimilarProductsResponse,
} from "./similarProducts.types";
import { handleApiError } from "@/app/utils/handleApiError";

/**
 * Get similar products by product slug
 */
export const getSimilarProducts = createAsyncThunk<
  SimilarProductsResponse,
  { slug: string; params: SimilarProductsRequest },
  { rejectValue: string }
>("similarProducts/getSimilarProducts", async ({ slug, params }, { rejectWithValue }) => {
  try {
    const response = await fetchSimilarProducts(slug, params);
    return response;
  } catch (error) {
    return rejectWithValue(handleApiError(error));
  }
});